import clsx from 'clsx';
import type { ReactNode } from 'react';

/**
 * Design System · Badge (tag retangular)
 * Cantos suaves (rounded, igual aos botões). Cor semântica consistente.
 * blue = ação/atual · green = ok/publicada · yellow = pendência · red = crítico/atraso
 * purple = tipo B/evento · gray = neutro/arquivo.
 */

export type BadgeVariant = 'blue' | 'green' | 'yellow' | 'red' | 'orange' | 'purple' | 'gray';

const VARIANTS: Record<BadgeVariant, string> = {
  blue:   'bg-blue/10 text-blue border-blue/30',
  green:  'bg-green/10 text-green border-green/30',
  yellow: 'bg-yellow/10 text-yellow border-yellow/30',
  red:    'bg-red/10 text-red border-red/30',
  orange: 'bg-orange/10 text-orange border-orange/30',
  purple: 'bg-purple/10 text-purple border-purple/30',
  gray:   'bg-panel-3 text-text-2 border-border',
};

interface BadgeProps {
  variant?: BadgeVariant;
  children: ReactNode;
  className?: string;
  /** ícone/elemento à esquerda (ex.: bolinha de status, lucide icon). */
  leading?: ReactNode;
}

export function Badge({ variant = 'gray', children, className, leading }: BadgeProps) {
  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1.5 px-2.5 py-1 rounded text-[10px] font-bold uppercase tracking-wide border',
        VARIANTS[variant],
        className,
      )}
    >
      {leading}
      {children}
    </span>
  );
}
